import { mutationOptions, type QueryClient } from '@tanstack/react-query';

import { issueQueryKeys } from '@/entities/issue';

import { createSignal } from './create-signal';
import { deleteSignal } from './delete-signal';
import { previewSignal } from './preview-signal';
import { signalQueryKeys } from './signal.queries';
import { updateSignal } from './update-signal';

/**
 * Signal 생성 mutationOptions
 */
export const createSignalMutationOptions = (queryClient: QueryClient) => {
  return mutationOptions({
    mutationFn: createSignal,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: signalQueryKeys.all });
      queryClient.invalidateQueries({ queryKey: issueQueryKeys.all });
    },
  });
};

/**
 * Signal 수정 mutationOptions
 */
export const updateSignalMutationOptions = (queryClient: QueryClient) => {
  return mutationOptions({
    mutationFn: updateSignal,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: signalQueryKeys.all });
      queryClient.invalidateQueries({ queryKey: issueQueryKeys.all });
    },
  });
};

/**
 * Signal 삭제 mutationOptions
 */
export const deleteSignalMutationOptions = (queryClient: QueryClient) => {
  return mutationOptions({
    mutationFn: deleteSignal,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: signalQueryKeys.all });
      queryClient.invalidateQueries({ queryKey: issueQueryKeys.all });
    },
  });
};

/**
 * Signal 프리뷰 mutationOptions
 */
export const previewSignalMutationOptions = () => {
  return mutationOptions({
    mutationFn: previewSignal,
  });
};
